export default "__VITE_ASSET__CGhIJYjh__"